import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'
import { gsap } from "gsap";

export default {

    init() {
        /* Script pour le module vidéo avec curseur, preview et ligne élastique */
        if ($(".module-hero-image-video")[0]) {
            $(".module-hero-image-video").each(function() {

                var videoContent = $(this);

                var iframe = videoContent.find('#video');

                if (iframe.length) {
                    var videoContentPlayer = new Vimeo.Player(iframe);
                    var videoContentOverlay = videoContent.find(".overlay");
                    var overlayClienRect = videoContentOverlay[0].getBoundingClientRect();
                    var cursor_custom = videoContent.find("#cursor_custom");

                    $(document).ready(function() {
                        videoContentPlayer.setVolume(0);

                        /* Animation de ligne élastique si désirée */
                        if (videoContent.find("#drawContainer")[0]) {
                            elasticLine();
                        } else {
                            // Initialise la taille de l'overlay
                            videoContentOverlay.css({ "width": iframe[0].getBoundingClientRect().width, "height": iframe[0].getBoundingClientRect().height });
                        }

                        overlayClienRect = videoContentOverlay[0].getBoundingClientRect();

                        cursor_custom.css({
                            left: overlayClienRect.width / 2,
                            top: overlayClienRect.height / 2
                        });


                        // Le curseur personnalisé va au centre de la page lorsque l'on quitte l'overlay
                        videoContentOverlay.bind('mouseout', function(e) {
                            cursor_custom.css({
                                left: overlayClienRect.width / 2,
                                top: overlayClienRect.height / 2
                            });
                        });
                    });

                    // Corrige la taille de l'overlay lorsque l'on change la taille de la page
                    $(window).resize(function() {
                        videoContentOverlay.css({ "width": iframe[0].getBoundingClientRect().width, "height": iframe[0].getBoundingClientRect().height });
                        overlayClienRect = videoContentOverlay[0].getBoundingClientRect();
                        cursor_custom.css({
                            left: overlayClienRect.width / 2 - cursor_custom.width() / 2,
                            top: overlayClienRect.height / 2
                        });
                        elasticLine();
                    });

                    // Video in pause if the video container is passed
                    if (videoContent.find('[data-pause]').length) {
                        $(window).on('scroll', function() {
                            const windowPosTop = $(this).scrollTop()
                            const heightVideo = overlayClienRect.height
                            const topPosVideo = iframe.offset().top

                            if (windowPosTop >= heightVideo + topPosVideo) {
                                videoContentPlayer.pause();
                            }
                        })
                    }


                    var running_time = 0;
                    var refreshIntervalId;
                    // Transition entre la preview et la vidéo et changement du contenu dans le curseur
                    videoContentOverlay.on("click", function() {
                        cursor_custom.toggleClass("video-content-play");

                        if (!cursor_custom.hasClass("video-content-play")) {
                            clearInterval(refreshIntervalId);
                            iframe.vimeo("play");
                            iframe.removeClass("preview");

                            if (!$(".audio-button").hasClass("mute")) {
                                videoContentPlayer.setVolume(1);
                            }
                            cursor_custom.find(".pause-cursor").removeClass("hidden-cursor");
                            cursor_custom.find(".play-cursor").addClass("hidden-cursor");

                            if ($(".concentrique")[0]) {
                                videoContent.find(".puces").css("visibility", "hidden");

                                videoContent.find(".concentrique").css("visibility", "hidden");

                                setTimeout(function() { videoContent.find(".legend-wrapper").css("display", "none"); }, 1000);

                            }

                        } else {
                            videoContentPlayer.pause();

                            cursor_custom.find(".play-cursor").removeClass("hidden-cursor");
                            cursor_custom.find(".pause-cursor").addClass("hidden-cursor");

                            if ($(".concentrique")[0]) {

                                videoContent.find(".puces").css("visibility", "visible");

                                videoContent.find(".concentrique").css("visibility", "visible");

                                videoContent.find(".legend-wrapper").css("display", "block");
                            }

                        }
                    })

                    // Le curseur de la souris est remplacé par une div lorsqu'elle bouge dans l'overlay
                    videoContentOverlay.on('mousemove', function(e) {

                        cursor_custom.css({
                            left: e.pageX - videoContentOverlay.offset().left,
                            top: e.pageY - videoContentOverlay.offset().top
                        });
                    });

                    function elasticLine() {
                        // Initialise la taille in-line de l'overlay pour afficher correctement la ligne
                        videoContentOverlay.attr("width", iframe[0].getBoundingClientRect().width);
                        videoContentOverlay.attr("height", iframe[0].getBoundingClientRect().height);

                        if (videoContent.find('#drawContainer')[0]) {
                            const canvasEle = videoContent.find('#drawContainer')[0];
                            const context = canvasEle.getContext('2d');

                            context.strokeStyle = "white";
                            context.lineWidth = 2;

                            // Position fixe d'une l'extrémité de la ligne
                            let startPosition = {
                                x: 300,
                                y: 450
                            };
                            let lineCoordinates = {
                                x: 0,
                                y: 0
                            };
                            let isDrawStart = false;

                            // Récupère les coordonnées du canvas
                            const getClientOffset = (event) => {
                                const {
                                    pageX,
                                    pageY
                                } = event.touches ? event.touches[0] : event;
                                const x = pageX - videoContentOverlay.offset().left;
                                const y = pageY - videoContentOverlay.offset().top;

                                return {
                                    x,
                                    y
                                }
                            }

                            const drawLine = () => {
                                context.beginPath();
                                context.moveTo(startPosition.x, startPosition.y);
                                context.lineTo(lineCoordinates.x, lineCoordinates.y);
                                context.stroke();
                            }

                            const mouseDownListener = (event) => {
                                //startPosition = getClientOffset(event);
                                isDrawStart = true;
                            }

                            // Dessine la ligne avec la position du curseur
                            const mouseMoveListener = (event) => {

                                if (!isDrawStart) return;
                                lineCoordinates = getClientOffset(event);
                                clearCanvas();
                                drawLine();
                            }

                            // Dessine la ligne pour qu'elle aille au centre de la page sur le curseur personnalisé
                            const mouseupListener = () => {
                                isDrawStart = false;

                                var x = overlayClienRect.width / 2 - cursor_custom.width() / 2;
                                var y = overlayClienRect.height / 2;

                                lineCoordinates = {
                                    x,
                                    y
                                };
                                clearCanvas();
                                drawLine();
                            }

                            const clearCanvas = () => {
                                context.clearRect(0, 0, canvasEle.width, canvasEle.height);
                            }

                            // Dessine la ligne initiale au chargement de la page
                            mouseupListener();
                            // Lorsque la souris se déplace dans le canvas, la ligne se dessine en suivant la souris
                            canvasEle.addEventListener('mousemove', mouseDownListener);
                            canvasEle.addEventListener("mousemove", mouseMoveListener);

                            canvasEle.addEventListener('mouseout', mouseupListener);

                        }

                    }
                }
            });
        }
    },
};